import React, { FunctionComponent } from "react";
import { ComponentItem } from "designSystem/types/component-item-types";
import SingleSelect, { SingleSelectProps } from "../select/SingleSelect";
import types from "csi/types";

const times: ComponentItem[] = [];

const localDate = new Date(0);
const adjustment = localDate.getTimezoneOffset() * 60;

for (let i = 0; i < 96; i++) {
	// time in seconds
	const newTime = i * 60 * 15;

	// time zone offset is in minutes
	let localTime = newTime + adjustment;
	// Client being changed to use milliseconds
	localTime = localTime * 1000;
	if (localTime == 0) {
		localTime = 1;
	}
	const title = types.formatTime(localTime, types.FORMAT_TIME);
	const newItem = {
		name: title,
		id: i.toString(),
		value: localTime,
	};
	times.push(newItem);
}

interface TimePickerProps extends Omit<SingleSelectProps<ComponentItem>, "options"> {

}

const TimePicker: FunctionComponent<TimePickerProps> = (props) => {
	return (
		<SingleSelect
			disableClearable
			inline
			options={times}
			{...props}
		/>
	);
};

export default TimePicker;